import { DesktopOnly, MobileOnly } from 'components/display/Breakpoints'
import { MapDesktop, MapMobile } from './icons'

const IconMap = () => {
  return (
    <>
      <DesktopOnly style={{ height: '100%' }} breakpoint="md">
        <MapDesktop />
      </DesktopOnly>
      <MobileOnly breakpoint="md">
        <MapMobile />
      </MobileOnly>
    </>
  )
}

export default IconMap
